import type { Types } from '../model';

interface ISendCodeResponse {
  allowSendAt: string;
  isRegistration: boolean;
}

export const useUserApi = () => {
  const { $jsonApi, $api } = useNuxtApp();

  const fetch = () => {
    return $jsonApi.prefix('api/current-user').get<Types.IUser>();
  };

  const logout = () => {
    return $jsonApi.prefix('api/auth/sign-out').post();
  };

  const sendCode = async (phone: string, token: string | null): Promise<ISendCodeResponse> => {
    const data = await $api<ISendCodeResponse>('api/auth/phone/send-code', {
      method: 'POST',
      body: {
        phone,
        captcha_token: token,
      },
    });

    return data;
  };

  const validateCode = (phone: string, code: string) => {
    return $api('api/auth/phone/confirm-code', {
      method: 'POST',
      body: {
        code,
        phone,
      },
    });
  };

  return { fetch, logout, sendCode, validateCode };
};
